import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '影视分类', to: '/category' },
  { label: '资讯专题', to: '/news' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = () => {
    const value = keyword.trim();
    if (!value) return;
    navigate(`/search?keyword=${encodeURIComponent(value)}`);
    setKeyword('');
    setMenuOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur transition-all duration-300 ${
        scrolled ? 'border-b border-background-200 shadow-sm' : 'border-b border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-film-line text-lg" />
            </span>
            <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
              红杏<span className="text-primary-600">影视</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `cursor-pointer whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <div className="flex h-9 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3">
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') submitSearch();
                }}
                type="text"
                placeholder="搜索片名或关键词"
                className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none lg:w-52"
              />
              <button
                type="button"
                onClick={submitSearch}
                className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                搜索
              </button>
            </div>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <div className="mb-4 flex h-11 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4">
            <i className="ri-search-line text-base text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') submitSearch();
              }}
              type="text"
              placeholder="搜索片名或关键词"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="button"
              aria-label="搜索"
              onClick={submitSearch}
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50"
            >
              <i className="ri-arrow-right-line text-sm" />
            </button>
          </div>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `cursor-pointer whitespace-nowrap rounded-md px-4 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}